import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderProps } from 'react-oidc-context';

import { isLoggedInVar } from '@store/reactiveVars';

// Sent automatically on the login code exchange. Renewal call sites must
// forward this explicitly — signinSilent's refresh grant only sends what the
// caller passes, and renewing without it can drop staff-context claims.
export const OIDC_EXTRA_TOKEN_PARAMS = { audience: 'apollo-gateway' };

export const oidcConfig: AuthProviderProps = {
  authority: process.env.REACT_APP_KEYCLOAK_REALM_URL,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  extraTokenParams: OIDC_EXTRA_TOKEN_PARAMS,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  // scope: 'openid profile email microprofile-jwt backend_audience roles',
  onSigninCallback: () => {
    isLoggedInVar(true);
  },
  revokeTokensOnSignout: true,
  onSignoutCallback: () => {
    isLoggedInVar(false);
  },
  stateStore: new WebStorageStateStore({ store: window.localStorage })
};
